import React from 'react';
import './ToggleButton.scss';

export interface ToggleOption {
  label: string;
  value: string | number;
}

interface ToggleButtonProps {
  options: ToggleOption[];
  selectedValue: string | number;
  onChange: (value: string | number) => void;
  className?: string;
  disabled?: boolean;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  options,
  selectedValue,
  onChange,
  className = '',
  disabled = false,
}) => {
  const handleClick = (value: string | number) => {
    if (!disabled) {
      onChange(value);
    }
  };

  return (
    <div className={`toggle-button-group ${className} ${disabled ? 'disabled' : ''}`}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`toggle-button ${selectedValue === option.value ? 'active' : ''}`}
          onClick={() => handleClick(option.value)}
          disabled={disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton;
